export default {
    methods: {
        /**
         * Navigate with router and then force page reload
         * This preserves the URL change but reloads the page
         */
        navigateWithReload(route) {
            this.$router.push(route).then(() => {
                window.location.reload();
            });
        },

        /**
         * Navigate with router and then force full page reload from server
         * This ensures fresh content from the server
         */
        navigateWithFullReload(route) {
            this.$router.push(route).then(() => {
                window.location.href = window.location.href;
            });
        },

        /**
         * Navigate with router and then force hard reload (bypass cache)
         * This ensures no cached content is used
         */
        navigateWithHardReload(route) {
            this.$router.push(route).then(() => {
                window.location.reload(true); // true forces reload from server
            });
        },

        /**
         * Navigate with router and then replace current URL and reload
         * This replaces the current history entry instead of adding a new one
         */
        navigateWithReplaceAndReload(route) {
            this.$router.replace(route).then(() => {
                window.location.reload();
            });
        },
    },
};
